import React from 'react'

// components
import ResponsiveButton from 'components/atoms/ResponsiveButton'

const EditButton = props => {
  const { adult, reupRequired, align } = props

  const path = `/pickup_people/${adult.id}/edit`
  const color = reupRequired && adult.confirmed ? 'primary' : 'secondary'

  return (
    <ResponsiveButton to={path} color={color} align={align}>
      {adult.confirmed ? 'Edit' : 'Confirm'}
    </ResponsiveButton>
  )
}

export default EditButton
